/**
 * View barrel — importing this module registers all routes.
 *
 * All views now use Galaxy components. Legacy views are no longer imported.
 */

import '../galaxy/views/fleet.js'
import '../galaxy/views/run.js'
import '../galaxy/views/work.js'
import '../galaxy/views/kb.js'
import '../galaxy/views/packs.js'
import '../galaxy/views/kb_graph.js'
import '../galaxy/views/kb_analytics.js'
